import IMG1 from "../../assets/portfolio1.jpg";
import IMG2 from "../../assets/portfolio2.jpg";
import IMG3 from "../../assets/portfolio3.jpg";
import IMG4 from "../../assets/portfolio4.jpg";
import IMG5 from "../../assets/portfolio5.png";
import IMG6 from "../../assets/portfolio6.jpg";

export const data = [
  {
    id: 1,
    image: IMG1,
    title: "Inteligent Tourist Guide (TourToise)",
    github: "https://github.com/Rouclec/TourToise",
    demo: "https://github.com/Rouclec/TourToise",
  },
  {
    id: 2,
    image: IMG2,
    title: "Health Monitoring App for Covid19 patients",
    github: "https://github.com/Ed-Gah/Gps",
    demo: "https://github.com/Ed-Gah/Gps",
  },
  {
    id: 3,
    image: IMG3,
    title: "Restaurant Search Application (MealsToGo)",
    github: "https://github.com/Rouclec/MealsToGo",
    demo: "https://github.com/Rouclec/MealsToGo",
  },
  {
    id: 4,
    image: IMG4,
    title: "Amazon Clone",
    github: "https://github.com/Ed-Gah/AmazonClone",
    demo: "https://github.com/Ed-Gah/AmazonClone",
  },
  {
    id: 6,
    image: IMG6,
    title: "Car Rental Management System",
    github: "https://github.com/Rouclec/CarRentalManagementSystem",
    demo: "https://github.com/Rouclec/CarRentalManagementSystem",
  },
];
